export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      3382.857142857143,
    ],
    button_spin: [
      5000,
      909.9319727891153,
    ],
    end_free_spin: [
      7000,
      2872.018140589569,
    ],
    free_bet_big_win: [
      11000,
      1377.2335600907031,
    ],
    free_bet_mega_win: [
      14000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      18000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      20000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      23000,
      34510.657596371886,
    ],
    free_spin_music: [
      59000,
      47127.800453514734,
    ],
    free_spin_popup: [
      108000,
      3905.3061224489766,
    ],
    free_spin_start: [
      113000,
      2062.2222222222176,
    ],
    inside_buttons: [
      117000,
      227.84580498866092,
    ],
    main_ambient: [
      119000,
      61344.21768707483,
    ],
    main_music: [
      182000,
      183167.70975056692,
    ],
    mega_win: [
      367000,
      4421.950113378671,
    ],
    outside_buttons: [
      373000,
      137.86848072561497,
    ],
    reel_spin: [
      375000,
      3108.5714285714516,
    ],
    reel_stop_01: [
      380000,
      271.3832199546573,
    ],
    reel_stop_02: [
      382000,
      262.6757369614552,
    ],
    reel_stop_03: [
      384000,
      259.7732426303878,
    ],
    reel_stop_04: [
      386000,
      230.74829931971408,
    ],
    reel_stop_05: [
      388000,
      222.04081632651196,
    ],
    regular_win: [
      390000,
      970.8843537414964,
    ],
    respin: [
      392000,
      3929.9773242630636,
    ],
    scatter_stop: [
      397000,
      1446.8934240362614,
    ],
    tap_to_play: [
      400000,
      3243.5374149659992,
    ],
    ultra_win: [
      405000,
      3835.6462585034024,
    ],
    wild_stop: [
      410000,
      1147.9365079364925,
    ],
  },
}
